import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyCallsFail from './components/WhyCallsFail';
import TasksSolved from './components/TasksSolved';
import TypicalMistakes from './components/TypicalMistakes';
import ProgramStructure from './components/ProgramStructure';
import SkillsLearned from './components/SkillsLearned';
import BeforeAfter from './components/BeforeAfter';
import CaseResults from './components/CaseResults';
import WhyProgramsWork from './components/WhyProgramsWork';
import Formats from './components/Formats';
import SuitableCompanies from './components/SuitableCompanies';
import WhyDifferent from './components/WhyDifferent';
import AboutAuthor from './components/AboutAuthor';
import CTASection from './components/CTASection';
import FinalCTA from './components/FinalCTA';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Программа', target: 'program' },
  { label: 'Результаты', target: 'cases' },
  { label: 'Форматы', target: 'formats' },
  { label: 'Тренер', target: 'trainer' },
  { label: 'FAQ', target: 'faq' },
];

export default function ColdCallsTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по холодным звонкам | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyCallsFail />
        <TasksSolved />
        <TypicalMistakes />
        <ProgramStructure />
        <SkillsLearned />
        <BeforeAfter />
        <CaseResults />
        <WhyProgramsWork />
        <Formats />
        <SuitableCompanies />
        <WhyDifferent />
        <AboutAuthor />
        <CTASection />
        <FinalCTA />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}